// extracted by mini-css-extract-plugin
export default {"container":"VoteSurvey_container__CgagE","fieldset":"VoteSurvey_fieldset__rnMKD","label":"VoteSurvey_label__cBOkE","flex":"VoteSurvey_flex__80XL5"};